export const AndroidDownLoadUrl = 'https://jianduoduo-cdn.mengyushanghai.com/jianduoduo-package/download/release/jianduoduo_android_10113.apk';
export const IosDownLoadUrl = 'https://itunes.apple.com/cn/app/1479144747';
